import React, { useEffect, useState } from 'react';
import BrandHeader from 'components/menu/BrandHeader';
import { connect } from 'react-redux';
import { selectAccessToken, selectProfessionalProfile } from 'selectors/authSelector';
import { Box, Button, Circle, Flex, Heading, IconButton, Image, Select, Spinner, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { selectUser } from 'selectors/authSelector';
import { selectAssociation } from 'selectors/authSelector';
import FilterTransactions from './components/SearchAndFilterTransaction';
import ToFirstPage from "../../../assets/img/dashboards/first.svg";
import ToLastPage from "../../../assets/img/dashboards/last.svg";
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import rdvService from 'services/rdvService';
import { useCallback } from 'react';

const Index = ({ user, accessToken, association, professional_profile }) => {
    const { t } = useTranslation();
    const [transactionsAllData, setTransactionsAllData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        status: "",
        from: null,
        to: null
    });
    const [totalResults, setTotalResults] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchType, setSearchType] = useState('file_number');

    const tableHeaderStyles = {
        textAlign: "start",
        fontSize: "16px",
        color: "#252525",
    };

    const tableContentStyles = {
        fontSize: "16px",
        fontWeight: "400",
        color: "#565656",
    };



    // Construct query string based on filters
    const constructQueryString = () => {
        let query = '?limit=10&'

        if (filters.status) {
            query += `payment_status=${filters.status}`;

        }
        if (searchQuery) query += `&${searchType}=${searchQuery}`;
        return query;
    };
    // Get all transactions list
    const getAllTransactionsList = async () => {
        const queryString = constructQueryString();
        // console.log("*** queryString ***", searchType, searchQuery)
        setLoading(true);
        try {
            const res = await rdvService.transactionsListAll(accessToken, queryString);
            console.log("getAllTransactionsList:", res?.data);
            setTransactionsAllData(res?.data);
            const total = Array.isArray(res.data) ? res.data.length : res.data.count || 0;
            setTotalResults(total);
        } catch (err) {
            console.log("err err err", err);
            setLoading(false);
            setTotalResults(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllTransactionsList();
    }, [filters, searchQuery]);

    const handleLimitChange = useCallback((e) => {
        const newLimit = Number(e.target.value);
        setFilters((prevFilters) => ({
            ...prevFilters,
            limit: newLimit,
            offset: 0 // Reset offset when limit changes
        }));
    }, []);

    const handleNextPage = useCallback(() => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            offset: prevFilters.offset + prevFilters.limit
        }));
    }, []);

    const handlePreviousPage = useCallback(() => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            offset: Math.max(prevFilters.offset - prevFilters.limit, 0)
        }));
    }, []);

    const handleFirstPage = useCallback(() => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            offset: 0
        }));
    }, []);

    const handleLastPage = useCallback(() => {
        setFilters((prevFilters) => {
            const lastPageOffset = Math.floor(totalResults / prevFilters.limit) * prevFilters.limit;
            return {
                ...prevFilters,
                offset: lastPageOffset
            };
        });
    }, [totalResults]);

    return (
        <div>
            <BrandHeader />
            <Flex
                direction={"column"}
                margin={3}
                border="1px"
                borderColor="gray.300"
                borderRadius={"8px"}
            >
                <Flex justifyContent={"space-between"} borderBottom="1px" borderColor="gray.300">
                    <Box
                        fontSize={"24px"}
                        fontWeight={"500"}
                        marginLeft={3}
                        marginY={"12px"}
                    >
                        {t('transactions.transactions')}
                    </Box>
                </Flex>

                <FilterTransactions
                    filters={filters}
                    setFilters={setFilters}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    searchType={searchType}
                    setSearchType={setSearchType}
                    handleSearch={getAllTransactionsList}
                    handleResetSearchAndFilter={() => {
                        setFilters({
                            status: "",
                            from: null,
                            to: null
                        });
                        setSearchQuery('');
                        setSearchType('file_number');
                    }}
                />

                <TableContainer>
                    <Table variant="simple">
                        <Thead>
                            <Tr>
                                <Th sx={tableHeaderStyles}>
                                    {t('transactions.file_number')}
                                </Th>
                                <Th sx={tableHeaderStyles}>
                                    {t('transactions.amount')}
                                </Th>
                                <Th sx={tableHeaderStyles}>
                                    {t('transactions.Session_name')}
                                </Th>
                                <Th sx={tableHeaderStyles}>
                                    {t('transactions.payment_method')}
                                </Th>
                                <Th sx={tableHeaderStyles}>
                                    {t('transactions.status')}
                                </Th>
                                <Th sx={tableHeaderStyles}>
                                    {t('transactions.customer')}
                                </Th>
                                <Th sx={tableHeaderStyles}>
                                    {t('transactions.payment_date')}
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {!loading ? (
                                transactionsAllData.length > 0 ? (
                                    transactionsAllData.map((data, index) => {
                                        const localDate = data?.payment_received_at ? new Date(data.payment_received_at) : null;
                                        const formattedDate = localDate
                                            ? new Intl.DateTimeFormat('default', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: true,
                                            }).format(localDate)
                                            : '-';

                                        return (
                                            <Tr key={index}>
                                                <Td sx={tableContentStyles}>{data?.file_number}</Td>
                                                <Td sx={tableContentStyles}>
                                                    {data?.transaction_amount}{' '}
                                                    <Text as="span" textTransform="uppercase">
                                                        {data?.transaction_currency}
                                                    </Text>
                                                </Td>
                                                <Td sx={tableContentStyles} textTransform="capitalize">
                                                    {data?.session_name || '-'}
                                                </Td>
                                                <Td sx={tableContentStyles} textTransform="capitalize">
                                                    {data?.payment_method || '-'}
                                                </Td>
                                                <Td sx={tableContentStyles}>
                                                    {t(`transactions.${data?.payment_status?.toLowerCase()}`, { defaultValue: data?.payment_status }) || '-'}
                                                </Td>

                                                <Td sx={tableContentStyles} textTransform="capitalize">
                                                    {data?.participant_names || '-'}
                                                </Td>
                                                <Td sx={tableContentStyles}>{formattedDate}</Td>
                                            </Tr>
                                        );
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={7} textAlign="center">
                                            <Text color="gray" fontSize="md" padding={5}>
                                                {t('transactions.no_transactions_found')}
                                            </Text>
                                        </Td>
                                    </Tr>
                                )
                            ) : (
                                <Tr>
                                    <Td colSpan={7} textAlign="center">
                                        <Spinner size="lg" thickness="3px" color="#FF6666" />
                                    </Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </Flex>


            <Flex justifyContent="flex-end" alignItems="center" mt={4}>
                <Text mr={4}>
                    {t("Rows_per_page")}
                    <Select
                        value={filters.limit}
                        onChange={handleLimitChange}
                        display="inline-block"
                        width="auto"
                        ml={2}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                    </Select>
                </Text>
                <Text mr={4}>
                    {/* {` ${filters.offset + 1}-${Math.min(filters.offset + filters.limit, totalResults)} of `} */}

                    {`${totalResults}`}
                </Text>
                <Flex>
                    <IconButton
                        onClick={handleFirstPage}
                        disabled={filters.offset === 0}
                        icon={<Image src={ToFirstPage} alt="First Page" />}
                        aria-label="First Page"
                        bg={'none'}
                        mr={2}
                    />
                    <IconButton
                        onClick={handlePreviousPage}
                        disabled={filters.offset === 0}
                        icon={<ChevronLeftIcon boxSize={6} />}
                        aria-label="Previous Page"
                        bg={'none'}
                        mr={2}
                    />
                    <IconButton
                        onClick={handleNextPage}
                        disabled={filters.offset + filters.limit >= totalResults}
                        icon={<ChevronRightIcon boxSize={6} />}
                        aria-label="Next Page"
                        bg={'none'}
                        mr={2}
                    />
                    <IconButton
                        onClick={handleLastPage}
                        disabled={filters.offset + filters.limit >= totalResults}
                        icon={<Image src={ToLastPage} alt="Last Page" />}
                        aria-label="Last Page"
                        border={'none'}
                        bg={'none'}
                    />
                </Flex>
            </Flex>
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: selectUser(state),
    accessToken: selectAccessToken(state),
    association: selectAssociation(state),
    professional_profile: selectProfessionalProfile(state),
});

export default connect(mapStateToProps)(Index);
